import Yup from "../mixins/yup";

const REQUIRED_MESSAGE = "Campo obrigatório";
const INVALID_DATE_MESSAGE = "Data inválida";

export const diagnosticHypothesisFilterSchema = Yup.object().shape({
	startDate: Yup.date().required(REQUIRED_MESSAGE).typeError(INVALID_DATE_MESSAGE),
	endDate: Yup.date().required(REQUIRED_MESSAGE).typeError(INVALID_DATE_MESSAGE),
	clinicOrSpecialty: Yup.object().shape({
		label: Yup.string().required(REQUIRED_MESSAGE),
	}),
	icd: Yup.object().shape({
		label: Yup.string().required(REQUIRED_MESSAGE),
	}),
});
